import { Box} from '@mui/material'
import { useAppSelector } from '../../Redux/store'
import { ClientApplications } from './Components/ClientApplications'
import { TalentApplications } from './Components/TalentApplications'
import { KaziLayout } from '../../Shared Components/Kazi/Layouts/KaziLayout'

export const Applications = () => {
    /* ******************** Hooks ******************** */
    const userType = useAppSelector( state => state.Global.userType);
    const isClient = userType === 'client';
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <KaziLayout>
            {isClient ? <ClientApplications /> : <TalentApplications />}
        </KaziLayout>
    )
}